// extracted by mini-css-extract-plugin
module.exports = {"page":"RatRaceLanding_page__Nzw9V","mobileScrollLock":"RatRaceLanding_mobileScrollLock__8qC7x"};